var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1409 17.9047C20.3965 17.1547 18.5937 16.0602 17.719 15.6191C16.58 15.0454 16.4862 14.9985 15.5909 15.6636C14.9937 16.1075 14.5967 16.5041 13.8978 16.355C13.1989 16.206 11.6801 15.3655 10.3503 14.0399C9.02042 12.7143 8.13121 11.1514 7.98167 10.4549C7.83214 9.75832 8.23527 9.36598 8.67496 8.76738C9.29464 7.92363 9.24777 7.78301 8.71808 6.64394C8.30511 5.75801 7.17871 3.97207 6.42589 3.23144C5.62058 2.43598 5.62058 2.5766 5.10167 2.79223C4.67922 2.96997 4.27394 3.18603 3.89089 3.43769C3.14089 3.93598 2.72464 4.34988 2.43355 4.97191C2.14246 5.59394 2.01167 7.05223 3.51496 9.78316C5.01824 12.5141 6.07292 13.9105 8.25589 16.0874C10.4389 18.2643 12.1175 19.4347 14.5714 20.811C17.607 22.5111 18.7714 22.1797 19.3953 21.8891C20.0192 21.5985 20.435 21.186 20.9342 20.436C21.1865 20.0536 21.403 19.6487 21.5811 19.2266C21.7971 18.7096 21.9378 18.7096 21.1409 17.9047Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallOutline);
export default __webpack_public_path__ + "static/media/call-outline.37c82dcf38e98c9a653e993468402d94.svg";
export { ForwardRef as ReactComponent };